export type VideoWidth = number | '100%';

export function videoWidth(value: unknown): VideoWidth {
    if (value === '100%') return value;
    const text = String(value ?? '').trim();
    if (!/^\d+(?:px)?$/.test(text)) return 640;
    return Math.max(200, Math.min(3840, parseInt(text, 10)));
}

export function videoFrameStyle(width: unknown): string {
    const size = videoWidth(width);
    return `width:${size === '100%' ? size : `${size}px`};max-width:100%;height:auto;aspect-ratio:16/9;display:block;border:0;box-sizing:border-box`;
}

export function videoBlockStyle(align: unknown): string {
    const alignment = align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center';
    return `display:flex;flex-direction:column;align-items:${alignment};width:100%;max-width:100%;min-width:0`;
}

/** Apply the same proportional sizing to saved/legacy videos in lesson views. */
export function prepareYouTubeVideos(doc: Document): void {
    doc.querySelectorAll<HTMLElement>('div.video-block').forEach(block => {
        const frame = block.querySelector<HTMLIFrameElement>(':scope > iframe');
        if (!frame) return;
        try {
            const url = new URL(frame.getAttribute('src') || '');
            if (url.protocol !== 'https:' || !['www.youtube.com', 'youtube.com', 'www.youtube-nocookie.com', 'youtube-nocookie.com'].includes(url.hostname)
                || !/^\/embed\/[\w-]+$/.test(url.pathname)) return;
        } catch { return; }
        const width = videoWidth(block.getAttribute('data-video-width') ?? frame.getAttribute('width') ?? (frame.style.width || undefined));
        block.setAttribute('data-video-width', String(width));
        const align = block.classList.contains('align-left') ? 'left' : block.classList.contains('align-right') ? 'right' : 'center';
        block.setAttribute('style', [block.getAttribute('style'), videoBlockStyle(align)].filter(Boolean).join(';'));
        frame.setAttribute('style', [frame.getAttribute('style'), videoFrameStyle(width)].filter(Boolean).join(';'));
        frame.setAttribute('title', frame.getAttribute('title') || 'YouTube video');
        frame.setAttribute('allowfullscreen', 'true');
    });
}
